import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'reactstrap'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'


const propTypes = {
  disabledDates         : PropTypes.array,
  onChangeDisabledDates : PropTypes.func,
  onUpdate              : PropTypes.func
}

/**
 * TODO: refactor this into dynamic setting field
 * @param {object} disabledDates - Setting disabled dates
 * @param {func} onChangeDisabledDates - Handler props to change disabled dates values
 * @param {func} onUpdate - Handler props to update dates values
 */
const DisabledDatePicker = ({
  disabledDates,
  onChangeDisabledDates,
  onUpdate
}) => {
  // Set values as empty array if disabledDates is empty
  const values = disabledDates.value ?? []

  const getISODate = (day) => day.toISOString().split('T')[0]

  const handleDayClick = (day, { selected }) => {
    if (selected) {
      const selectedDaysArray = values.map( (date) => new Date(date))
      const selectedIndex     = selectedDaysArray.findIndex((selectedDay) => DateUtils.isSameDay(selectedDay, day))
      values.splice(selectedIndex, 1)
    } else {
      values.push(getISODate(day))
    }

    onChangeDisabledDates(values)
  }

  const selectedDays = () => {
    if (Array.isArray(values)) return values.map((date) => new Date(date))
  }

  return (
    <>
      <DayPicker
        selectedDays={ selectedDays() }
        onDayClick={ handleDayClick }
        className="disabled-dates-field"
      />

      <Button
        color='primary'
        onClick={ () => onUpdate(disabledDates) }
      >
        { 'Save' }
      </Button>
    </>
  )
}

DisabledDatePicker.propTypes = propTypes

export default DisabledDatePicker